import type { EmailTemplate } from 'header/types';

export const initEmailData: EmailTemplate = {
    recipient: '',
    subject: 'Support request for portlet',
    description: 'Issue description',
};
